import { IdLeagueGifts } from "../../constants/IdLeagueGifts";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { IdIcon } from "../generic/icon/IdIcon";
export var buttonGiftInfoMap = new Map([
    [
        IdLeagueGifts.LeaguePremiumOffer,
        {
            buttonColour: IdStyles.ButtonHighlight,
            icon: IdIcon.GiftPremiumIcn,
            loca: IdLoca.leagueMenuRewardOffer,
        },
    ],
    [
        IdLeagueGifts.LeagueGoldGift,
        {
            buttonColour: IdStyles.ButtonPrimaryAccent,
            icon: IdIcon.GiftGoldIcn,
            loca: IdLoca.leagueMenuRewardGoldPackage,
        },
    ],
    [
        IdLeagueGifts.LeagueFreeGift,
        {
            buttonColour: IdStyles.ButtonPrimary,
            icon: IdIcon.GiftFreeIcn,
            loca: IdLoca.leagueMenuRewardGift,
        },
    ],
]);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/buttonGiftInfoMap.ts
// module id = 2791
// module chunks = 3